module.exports = __webpack_public_path__ + "img/pic_guanli@2x.a691a17a.png";